import axios from '@axios'

export default function (route = '') {
  const PREFIX = `parcelamentos/${route}`

  return {
    getPaginado(page, pageSize, filtros) {
      return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`, filtros)
    },

    getParcelas(parcelamentoId) {
      return axios.get(`${PREFIX}/${parcelamentoId}/parcelas`)
    },

    getParcelasRecentes(parcelamentoId) {
      return axios.get(`${PREFIX}/${parcelamentoId}/parcelas-recentes`)
    },

    getGuiaParcela(parcelamentoId, parcelaId) {
      if (parcelaId) {
        return axios.get(`${PREFIX}/${parcelamentoId}/guia/${parcelaId}`)
      }
      return axios.get(`${PREFIX}/${parcelamentoId}/guia`)
    },

    baixaEmLote(filtros, nomeArquivo) {
      return axios.post(`${PREFIX}/baixa-lotes?nomeArquivo=${nomeArquivo}`, filtros)
    },

    /**
   * Envia um email com link para download.
   *
   * obs: Se não houver parcela informada, é considerada a ultima parcela lida para notificar
   * @param {string} nomeEmpresa
   * @param {string} emailEmpresa
   * @param {string} emailCc
   * @param {string} mensagemAdicional
   * @param {number} id Identificador do parcelamento
   * @param {number} parcelaId Identificador de uma parcela especifica
   * @returns
   */
    enviarEmail(nomeEmpresa, emailEmpresa, emailCc, id, parcelaId, mensagemAdicional, definirEmailPadrao) {
      if (parcelaId) {
        return axios.post(`${PREFIX}/${id}/parcela/${parcelaId}/notifica?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional)}&definirEmailPadrao=${definirEmailPadrao}`)
      }
      return axios.post(`${PREFIX}/${id}/notifica?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional)}&definirEmailPadrao=${definirEmailPadrao}`)
    },

    getObservacoes(id) {
      return axios.get(`${PREFIX}/${id}/observacao`)
    },

    removerObservacao(id) {
      return axios.delete(`${PREFIX}/observacao/${id}/remover`)
    },

    salvarObservacao(observacao) {
      return axios.post(`${PREFIX}/observacao/salvar`, observacao)
    },
  }
}
